export class CannotRefreshAccessTokenError extends Error {
  message = 'Cannot refresh access token';
}
